module.exports = __webpack_public_path__ + "img/Rectangle3.da79d8f.png";